import styled from '@emotion/styled';
import { EmotionBreakpoint, BrandUtil } from 'dw-us-ui';
import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { Pagination } from '../../components/Pagination/Pagination';
import { ReferenceCardWrapper } from '../ReferenceCardWrapper/ReferenceCardWrapper';

const Section = styled.section`
  margin-left: auto;
  margin-right: auto;
  padding: 30px 15px 15px;
  width: 100%;
  .container {
    max-width: 970px;
    margin-left: auto;
    margin-right: auto;
    padding-left: 15px;
    padding-right: 15px;
    width: 100%;
  }
  .align-container {
    display: flex;
    flex-wrap: wrap;
  }
  .reference-card-item {
    width: 470px;
    padding-right: 15px;
    padding-bottom: 15px;
  }
  .reference-card-section-heading {
    text-align: left;
    margin-bottom: 22px;
    align-items: center;
    flex-direction: row;
    justify-content: space-between;
    display: flex;
    .back-to-home {
      padding-right: 15px;
    }
  }
  ${EmotionBreakpoint('desktop')} {
    max-width: 970px;
  }
  ${EmotionBreakpoint('tablet')} {
    max-width: 720px;
    .reference-card-item {
      width: 345px !important;
    }
  }
  @media (min-width: 576px) and (max-width: 768px) {
    max-width: 540px;
    .reference-card-item {
      width: 100% !important;
    }
  }
`;

const ReferenceCardSection = ({ header, cards }) => {
  const initialPaginationDetails = {
    itemsPerPage: '',
    totalItems: '',
    totalPages: '',
    firstItem: '',
    lastItem: '',
    activeCards: [],
    current: '',
    prev: '',
    next: '',
  };
  const [paginationDetails, setPaginationDetails] = useState(initialPaginationDetails);
  const brand = BrandUtil.getBrand();
  const brandTag = BrandUtil.content(brand).tag.toLowerCase();
  const history = useHistory();
  const pageparam = parseInt(history?.location?.search.replace('?page=', ''));
  const [pageNo, setPageNo] = useState(pageparam || 1);

  useEffect(() => {
    let itemsPerPage = 10;
    let totalItems = cards?.length;
    let totalPages = Math?.ceil(totalItems / itemsPerPage);
    let firstItem = (pageNo - 1) * itemsPerPage;
    let lastItem = firstItem + itemsPerPage;

    let activeCards = cards?.slice(firstItem, lastItem);
    let current = pageNo;
    let prev = pageNo === 1 ? true : false;
    let next = pageNo === totalPages ? true : false;

    setPaginationDetails({
      itemsPerPage,
      totalItems,
      totalPages,
      firstItem,
      lastItem,
      activeCards,
      current,
      prev,
      next,
    });
  }, [cards, pageNo]);

  const renderCardType = refCard => {
    return <ReferenceCardWrapper refCard={refCard.fields} brand={brandTag} />;
  };

  const updatePageNo = buttonDir => {
    switch (buttonDir) {
      case 'next':
        setPageNo(pageNo + 1);
        history.push(`?page=${pageNo + 1}`);
        break;
      case 'prev':
        setPageNo(pageNo - 1);
        history.push(`${pageNo === 2 ? '' : `?page=${pageNo - 1}`}`);
        break;
      default: {
        setPageNo(buttonDir);
      }
    }
  };

  return (
    <Section>
      <>
        <div className="pt-5 pb-5">
          {header && (
            <div data-testid="reference-card-section-heading" className="mx-0 mb-5">
              <div className="p-0 reference-card-section-heading">
                <h2>{header}</h2>
              </div>
            </div>
          )}
          <div className="ml-md-0 align-container">
            {paginationDetails?.activeCards?.map((card, index) => (
              <div className="pb-4 pl-md-0 reference-card-item" xs={12} md={6} key={index}>
                {renderCardType(card)}
              </div>
            ))}
          </div>
        </div>
        <Pagination
          current={paginationDetails?.current}
          total={paginationDetails?.totalPages}
          next={paginationDetails?.next}
          prev={paginationDetails?.prev}
          updatePageNo={updatePageNo}
        />
      </>
    </Section>
  );
};

export { ReferenceCardSection };
